import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Sidebar = ({ status }) => {
  let activeStyle = "active";
  const location = useLocation();
  const [isSaudiaCompetitionOpen, setIsSaudiaCompetitionOpen] = useState(
    location.pathname.startsWith("/saudia-competitions-management") || location.pathname.startsWith("/form-master")
  );
  const [isQuizAndGameOpen, setIsQuizAndGameOpen] = useState(
    location.pathname.startsWith("/quiz-and-game-management") || 
    location.pathname.startsWith("/survey-form-master") ||
    location.pathname.startsWith("/user-quiz-response")
  );

  return (
    <>
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav w-100">
          <NavLink to="/dashboard" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : ""}`}>
                <a className="nav-link">
                  <span className="menu-title">Dashboard</span> <i className="mdi mdi-calendar-text menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/banner-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Banner Management</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/win-ticket-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Win Ticket</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/news-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">News</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <li className={`nav-item ${isQuizAndGameOpen ? "open" : ""} ${location.pathname.startsWith("/quiz-and-game-management") || location.pathname.startsWith("/survey-form-master") || location.pathname.startsWith("/user-quiz-response") ? activeStyle : undefined}`}>
            <a
              className="nav-link w-100 hasDropdown"
              onClick={(e) => {
                e.preventDefault();
                setIsQuizAndGameOpen(!isQuizAndGameOpen);
              }}
              style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            >
              <span className="menu-title w-100">Quiz &amp; Game</span>
              <i className="mdi mdi-speedometer menu-icon" />
              <i className={`mdi ${isQuizAndGameOpen ? "mdi-chevron-down" : "mdi-chevron-right"}`} style={{ marginLeft: "auto", fontSize: "1rem", transition: "transform 0.3s" }} />
            </a>
            <ul className="dropdown-menu" style={{ display: isQuizAndGameOpen ? "block" : "none" }}>
              <NavLink to="/quiz-and-game-management" style={{ textDecoration: "none" }}>
                {({ isActive }) => (
                  <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                    <a className="nav-link dropdown-item w-100">
                      <span className="menu-title w-100">Quiz and Game Management</span>
                    </a>
                  </li>
                )}
              </NavLink>
              <NavLink to="/survey-form-master" style={{ textDecoration: "none" }}>
                {({ isActive }) => (
                  <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                    <a className="nav-link dropdown-item w-100">
                      <span className="menu-title w-100">Survey Form Master</span>
                    </a>
                  </li>
                )}
              </NavLink>
              <NavLink to="/user-quiz-response" style={{ textDecoration: "none" }}>
                {({ isActive }) => (
                  <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                    <a className="nav-link dropdown-item w-100">
                      <span className="menu-title w-100">User Quiz Response</span>
                    </a>
                  </li>
                )}
              </NavLink>
            </ul>
          </li>
          <NavLink to="/partner-update-type-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Partner Update Type</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/partner-update-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Partner Update</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <li className={`nav-item ${isSaudiaCompetitionOpen ? "open" : ""} ${location.pathname.startsWith("/saudia-competitions-management") || location.pathname.startsWith("/form-master") ? activeStyle : undefined}`}>
            <a
              className="nav-link w-100 hasDropdown"
              onClick={(e) => {
                e.preventDefault();
                setIsSaudiaCompetitionOpen(!isSaudiaCompetitionOpen);
              }}
              style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            >
              <span className="menu-title w-100">Saudia Competitions</span>
              <i className="mdi mdi-speedometer menu-icon" />
              <i className={`mdi ${isSaudiaCompetitionOpen ? "mdi-chevron-down" : "mdi-chevron-right"}`} style={{ marginLeft: "auto", fontSize: "1rem", transition: "transform 0.3s" }} />
            </a>
            <ul className="dropdown-menu" style={{ display: isSaudiaCompetitionOpen ? "block" : "none" }}>
              <NavLink to="/saudia-competitions-management" style={{ textDecoration: "none" }}>
                {({ isActive }) => (
                  <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                    <a className="nav-link dropdown-item w-100">
                      <span className="menu-title w-100">Saudia Competition Management</span>
                    </a>
                  </li>
                )}
              </NavLink>
              <NavLink to="/form-master" style={{ textDecoration: "none" }}>
                {({ isActive }) => (
                  <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                    <a className="nav-link dropdown-item w-100">
                      <span className="menu-title w-100">Form Master</span>
                    </a>
                  </li>
                )}
              </NavLink>
            </ul>
          </li>
          <NavLink to="/saudia-moment" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Saudia Moment</span> <i className="mdi mdi-image menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/partner-streams-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Partner Streams</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/saudia-holiday-management" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Saudia Holiday</span> <i className="mdi mdi-calendar menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/booking-ticket" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Booking Ticket</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/sound-track" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Sound Track</span> <i className="mdi mdi-music-circle menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
          <NavLink to="/content-management-system" style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <li className={`nav-item ${isActive ? activeStyle : undefined}`}>
                <a className="nav-link w-100">
                  <span className="menu-title w-100">Content Management System</span> <i className="mdi mdi-speedometer menu-icon" />
                </a>
              </li>
            )}
          </NavLink>
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
